import Button from "@mui/lab/LoadingButton"
import { styled } from "@mui/material/styles"

export const StyledButton = styled(Button)({
  "&&": {
    textTransform: `none`,
  },
})
